import { useNavigate } from '@tanstack/react-router'
import { WalletCardsIcon } from 'lucide-react'

import { SidebarItem, Skeleton } from '@/components/ui'
import { useAccount, useLoadingAccount } from '@/modules/account'
import { cn } from '@/utils'

export const ManageSubscriptionButton = () => {
  const account = useAccount()
  const navigate = useNavigate()
  const loadingAccount = useLoadingAccount()

  const handleManageSubscription = () => {
    navigate({ to: '/billing' })
  }
  if (loadingAccount) {
    return (
      <SidebarItem icon={WalletCardsIcon}>
        <Skeleton className="h-5 w-32" />
      </SidebarItem>
    )
  }

  return (
    <SidebarItem
      onClick={handleManageSubscription}
      className={cn(account?.isDemo && 'hidden')}
      icon={WalletCardsIcon}
    >
      Billing
    </SidebarItem>
  )
}
